"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAndSiteSettingsProvider = exports.useUserSiteSettings = exports.UserAndSiteSettingsContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.UserAndSiteSettingsContext = react_1.default.createContext({
    areUsersVisible: false,
    isUserAdmin: false,
    helpUrlParams: {
        offlineHelpEnabled: false,
        serverHelpEdition: '',
        sessionLanguage: '',
        serverPlatform: '',
        serverVersion: {
            major: '',
            minor: '',
        },
    },
});
function useUserSiteSettings() {
    return react_1.default.useContext(exports.UserAndSiteSettingsContext);
}
exports.useUserSiteSettings = useUserSiteSettings;
function UserAndSiteSettingsProvider(props) {
    return (react_1.default.createElement(exports.UserAndSiteSettingsContext.Provider, { value: props.value }, props.children));
}
exports.UserAndSiteSettingsProvider = UserAndSiteSettingsProvider;
//# sourceMappingURL=UserAndSiteSettingsContext.js.map